import { Bolt, Category, Sell, Stadium } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import {
  FilterAccordionContainer,
  FilterCollapsibleList,
  FilterContainer,
  FilterFooter,
  FilterHeader,
} from '~/components/Filter';
import type { NetworkDeviceSignals__FilterInfo } from '../../queries/list.generated';
import { useSignalFilters } from '../context';

export interface SignalFilterAccordionProps {
  filterCounts: NetworkDeviceSignals__FilterInfo | undefined;
}

export const SignalFilterAccordion = ({ filterCounts }: SignalFilterAccordionProps) => {
  const { t } = useTranslation();
  const { clearFilters, filters, setFilter, toggleFilter } = useSignalFilters();

  return (
    <FilterContainer>
      <FilterHeader />
      <FilterAccordionContainer>
        {filters.tags.items.length > 0 && (
          <FilterCollapsibleList
            Icon={Sell}
            expanded={filters.tags.open}
            items={filters.tags.items.map((item) => {
              const matched = filterCounts?.tags.find((c) => c.filter === item.value);
              return { ...item, count: matched?.count || 0 };
            })}
            label={t('common.labels.tags')}
            loading={!filterCounts}
            onClick={(_, items) => setFilter({ field: 'tags', items })}
            onExpand={() => toggleFilter('tags')}
          />
        )}
        <FilterCollapsibleList
          Icon={Category}
          expanded={filters.kind.open}
          items={filters.kind.items.map((item) => {
            const matched = filterCounts?.kind.find(
              (c) => c.filter.toLowerCase() === item.value.toLowerCase(),
            );
            const label =
              item.value === 'EVENT'
                ? t('pages.device_signals.settings.fields.kind.event')
                : t('pages.device_signals.settings.fields.kind.manual');
            return { ...item, label, count: matched?.count || 0 };
          })}
          label={t('common.labels.type')}
          loading={!filterCounts}
          onClick={(_, items) => setFilter({ field: 'kind', items })}
          onExpand={() => toggleFilter('kind')}
        />
        {filters.eventType.items.length > 0 && (
          <FilterCollapsibleList
            Icon={Stadium}
            expanded={filters.eventType.open}
            items={filters.eventType.items.map((item) => {
              const matched = filterCounts?.eventType.find((c) => c.filter === item.value);
              return { ...item, count: matched?.count || 0 };
            })}
            label={t('pages.device_signals.list.columns.event_type')}
            loading={!filterCounts}
            onClick={(_, items) => setFilter({ field: 'eventType', items })}
            onExpand={() => toggleFilter('eventType')}
          />
        )}
        <FilterCollapsibleList
          Icon={Bolt}
          expanded={filters.action.open}
          items={filters.action.items.map((item) => {
            const matched = filterCounts?.action.find(
              (c) => c.filter.toLowerCase() === item.value.toLowerCase(),
            );
            const label = t(`pages.device_signals.settings.actions.${item.value.toLowerCase()}`);
            return { ...item, label, count: matched?.count || 0 };
          })}
          label={t('common.labels.action')}
          loading={!filterCounts}
          onClick={(_, items) => setFilter({ field: 'action', items })}
          onExpand={() => toggleFilter('action')}
        />
      </FilterAccordionContainer>
      <FilterFooter handleClear={clearFilters} />
    </FilterContainer>
  );
};
